export default __webpack_public_path__ + "static/media/ponentes__Ata Renewables.78ff558c.jpg";